import { DatePipe } from '@angular/common';
import { APP_INITIALIZER, NgModule, Provider } from '@angular/core';
import { Contacts } from '@ionic-native/contacts/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Network } from '@ionic-native/network/ngx';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { Screenshot } from '@ionic-native/screenshot/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Config } from '@ionic/angular';
import { ContactsService } from './contacts.service';
import { GalleryService } from './gallery.service';
import { PlatformService } from './platform.service';
import { PopoverService } from './popover.service';

function initializeAppFactory(psvcPlatform: PlatformService): () => Promise<void> {
	return () => psvcPlatform.initPlatformInfo()
}

const providers: Provider[] = [
	SocialSharing,
	Screenshot,
	OpenNativeSettings,
	InAppBrowser,
	DatePipe,
	Network,
	Contacts,
	Config,
	PopoverService,
	GalleryService,
	ContactsService,
	{ provide: APP_INITIALIZER, deps: [PlatformService], useFactory: initializeAppFactory, multi: true }
];

/** Ce module regroupe les services généraux de la bibliothèque et les instancie. */
@NgModule({
	imports: [],
	exports: [],
	declarations: [],
	providers: providers
})
export class ServiceModule { }
